import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import QACommentEntity from "../../../../domain/entities/qa_comment.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import QACommentDto from "../../../dto/qa_comment.dto";

const getAgentCommentsApiImpl = async ({ agentId, startDate, endDate }: { agentId: string; startDate: Date; endDate: Date; }): Promise<Either<ErrorEntity, QACommentEntity[]>> => {
    try {
        const relativeUrl = `/comment/${agentId}?start_date=${startDate.toISOString()}&end_date=${endDate.toISOString()}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl, {
            contentType: 'application/json',
        });
        const parsed = response.map((item: any) => QACommentDto.fromJSON(item));
        return right(parsed);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default getAgentCommentsApiImpl;